import { Route, Routes, useNavigate } from "react-router-dom";
import About from "./components/About";
import AllProductPage from "./components/AllProductPage";
import Login from "./components/Auth/Login/index";
import Profile from "./components/Auth/Profile";
import Signup from "./components/Auth/Signup";
import BecomeSaller from "./components/BecomeSaller";
import Blogs from "./components/Blogs";
import Blog from "./components/Blogs/Blog.jsx";
import BuyNowPage from "./components/BuyNowPage";
import CardPage from "./components/CartPage";
import CheakoutPage from "./components/CheakoutPage";
import CheckoutSuccess from "./components/CheckoutSuccess/index.jsx";
import Contact from "./components/Contact";
import Faq from "./components/Faq";
import FlashSale from "./components/FlashSale";
import FourZeroFour from "./components/FourZeroFour";
import Home from "./components/Home";
import PrivacyPolicy from "./components/PrivacyPolicy";
import ProductsCompaire from "./components/ProductsCompaire/index";
import SallerPage from "./components/SallerPage";
import Sallers from "./components/Sellers";
import SingleProductPage from "./components/SingleProductPage";
import TermsCondition from "./components/TermsCondition/index";
import ReturnRefundPolicy from "./components/ReturnRefundPolicy/index";
import TrackingOrder from "./components/TrackingOrder";
import Wishlist from "./components/Wishlist";
import RequireAuth from "./components/RequireAuth";
import PersistLogin from "./components/PersistLogin";
import CategoryProductPage from "./components/CategoryProductPage/index.jsx";
import BrandProductPage from "./components/BrandProductPage/index.jsx";
import SearchPage from "./components/SearchPage/index.jsx";
import CheckoutFail from "./components/CheckoutFail/index.jsx";

export default function Routers() {
  return (
    <Routes>
      <Route exact path="/" element={<Home />} />
      <Route exact path="/all-products" element={<AllProductPage />} />
      <Route
        exact
        path="/category/:categoryId"
        element={<CategoryProductPage />}
      />
      <Route exact path="/search" element={<SearchPage />} />
      <Route exact path="/search/:searchTerm" element={<SearchPage />} />
      <Route exact path="/brand/:brand" element={<BrandProductPage />} />
      <Route exact path="/single-product/:id" element={<SingleProductPage />} />
      <Route exact path="/cart" element={<CardPage />} />
      <Route exact path="/checkout" element={<CheakoutPage />} />
      <Route exact path="/buy-now" element={<BuyNowPage />} />
      <Route exact path="/checkout-success" element={<CheckoutSuccess />} />
      <Route exact path="/checkout-fail" element={<CheckoutFail />} />
      <Route exact path="/wishlist" element={<Wishlist />} />
      <Route exact path="/flash-sale" element={<FlashSale />} />
      <Route exact path="/saller-page" element={<SallerPage />} />
      <Route exact path="/products-compaire" element={<ProductsCompaire />} />
      <Route exact path="/sallers" element={<Sallers />} />
      <Route exact path="/about" element={<About />} />
      <Route exact path="/blogs" element={<Blogs />} />
      <Route exact path="/blogs/blog" element={<Blog />} />
      <Route exact path="/tracking-order" element={<TrackingOrder />} />
      <Route exact path="/faq" element={<Faq />} />
      <Route exact path="/login" element={<Login />} />
      <Route exact path="/signup" element={<Signup />} />
      <Route exact path="/become-saller" element={<BecomeSaller />} />
      <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route exact path="/terms-conditions" element={<TermsCondition />} />
      <Route
        exact
        path="/retun-refund-policy"
        element={<ReturnRefundPolicy />}
      />
      <Route exact path="*" element={<FourZeroFour />} />
      <Route exact path="/contact" element={<Contact />} />
      {/*protected routes*/}
      <Route element={<PersistLogin />}>
        <Route element={<RequireAuth />}>
          <Route exact path="/profile" element={<Profile />} />
        </Route>
      </Route>
    </Routes>
  );
}
